import React, { useEffect, useState } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import RequestService from "../../../services/RequestService";
import ReverseService from "../../../services/ReverseService";
import MinorRequestDetails from './../../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../../enums/StatusRequests'
import { MdSend } from "react-icons/md";
import { useForm } from "react-hook-form";

export default function CreateReverseModal({
  isModalOpen,
  setModalOpen,
  requestId,
  isFromGestao,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

    const [requestObject, setRequestObject] = useState();

    useEffect(() => {

        async function fetchRequest() {
            const request = await RequestService.getRequestById(requestId);
            setRequestObject(request);
            // console.log(request?.request.idRequest);
        }

        fetchRequest();

    }, [isModalOpen, requestId]);
  

  const onSubmit = async () => {
  
      const response = await ReverseService.createReverse(requestId);
  
      if (response) {
        toast.success("Reversa criada!");
      } else {
        // console.log(error)
        toast.error("Ops! Não foi possível criar Reversa!");
      }

    setModalOpen(!isModalOpen);

    
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[780px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">
                <div className="flex justify-between gap-2">
                    <div className="flex gap-2 items-center text-white text-xl font-bold">
                        <MdSend />
                        CRIAR REVERSA PARA UMA SOLICITAÇÃO
                    </div>
                    {requestObject?.request?.isReplica &&
                        <div>
                        <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                            RÉPLICA SGRS
                        </p>
                        </div>
                    }
                </div>
                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p  className="text-sm text-black rounded-lg px-2"
                        style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              <MinorRequestDetails request={requestObject?.request} divBoleto={true} />

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-12">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm">
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">

                      <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Deseja realmente criar uma reversa para esta solictação?
                      </div>
                      {/* <div className="w-1/5 block text-red-700 italic whitespace-nowrap">
                        Esta ação não pode ser desfeita
                      </div> */}
                    </div>

                    <div className="flex gap-4">
                      <button
                        // onClick={() => onSubmit(requestId)}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-yellow-400 text-white py-2 px-4 rounded-2xl hover:bg-yellow-600"
                      >
                        Sim
                      </button>

                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-gray-500 text-white py-2 px-4 rounded-2xl hover:bg-gray-600"
                      >
                        Não
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
